// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file agentops/v1/agentops.proto (package agentops.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { AgentExecution_Status, AgentResponseBlock as AgentResponseBlock$1, MCPIntegration, PullRequest, SupportedModel, UserInputBlock } from "../../gitpod/v1/agent_pb";
import { file_gitpod_v1_agent } from "../../gitpod/v1/agent_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentops/v1/agentops.proto.
 */
export const file_agentops_v1_agentops: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_v1_agent, file_google_protobuf_timestamp]);

/**
 * @generated from message agentops.v1.Conversation
 */
export type Conversation = Message<"agentops.v1.Conversation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message agentops.v1.Conversation.
 * Use `create(ConversationSchema)` to create a new message.
 */
export const ConversationSchema: GenMessage<Conversation> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 0);

/**
 * @generated from message agentops.v1.CreateConversationRequest
 */
export type CreateConversationRequest = Message<"agentops.v1.CreateConversationRequest"> & {
  /**
   * agent_execution_id is the ID of the agent execution that will handle this conversation
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;

  /**
   * llm_access_token is the access token for the LLM service
   *
   * @generated from field: string llm_access_token = 2;
   */
  llmAccessToken: string;

  /**
   * llm_endpoint is the endpoint URL for the LLM service
   *
   * @generated from field: string llm_endpoint = 3;
   */
  llmEndpoint: string;

  /**
   * supported_model is the LLM model to use for this conversation
   *
   * @generated from field: gitpod.v1.SupportedModel supported_model = 4;
   */
  supportedModel: SupportedModel;

  /**
   * mcp_access_token is the access token for MCP services
   *
   * @generated from field: string mcp_access_token = 5;
   */
  mcpAccessToken: string;

  /**
   * mcp_integrations are the MCP integrations to use for this conversation
   *
   * @generated from field: repeated gitpod.v1.MCPIntegration mcp_integrations = 6;
   */
  mcpIntegrations: MCPIntegration[];

  /**
   * pull_request contains PR context when the agent is working on a pull request
   *
   * @generated from field: gitpod.v1.PullRequest pull_request = 7;
   */
  pullRequest?: PullRequest;

  /**
   * name is the name of the conversation
   *
   * @generated from field: string name = 9;
   */
  name: string;

  /**
   * mcp_token_expiry is when the MCP access token expires
   *
   * @generated from field: google.protobuf.Timestamp mcp_token_expiry = 10;
   */
  mcpTokenExpiry?: Timestamp;

  /**
   * scm_tools_enabled indicates whether SCM tools should be available for this conversation
   *
   * @generated from field: bool scm_tools_enabled = 11;
   */
  scmToolsEnabled: boolean;

  /**
   * annotations are key-value pairs from the agent execution metadata.
   * Used to pass external context (e.g., Linear session IDs) to the agent runtime.
   *
   * @generated from field: map<string, string> annotations = 12;
   */
  annotations: { [key: string]: string };

  /**
   * is_server_side_tool_search_enabled indicates whether the LLM provider
   * supports Anthropic's server-side BM25 tool search. Computed by the
   * management plane and forwarded to the in-env engine.
   *
   * @generated from field: bool is_server_side_tool_search_enabled = 13;
   */
  isServerSideToolSearchEnabled: boolean;
};

/**
 * Describes the message agentops.v1.CreateConversationRequest.
 * Use `create(CreateConversationRequestSchema)` to create a new message.
 */
export const CreateConversationRequestSchema: GenMessage<CreateConversationRequest> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 1);

/**
 * @generated from message agentops.v1.CreateConversationResponse
 */
export type CreateConversationResponse = Message<"agentops.v1.CreateConversationResponse"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message agentops.v1.CreateConversationResponse.
 * Use `create(CreateConversationResponseSchema)` to create a new message.
 */
export const CreateConversationResponseSchema: GenMessage<CreateConversationResponse> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 2);

/**
 * @generated from message agentops.v1.UpdateConversationRequest
 */
export type UpdateConversationRequest = Message<"agentops.v1.UpdateConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * mcp_access_token is the new access token for MCP services
   *
   * @generated from field: string mcp_access_token = 2;
   */
  mcpAccessToken: string;

  /**
   * mcp_token_expiry is when the MCP access token expires
   *
   * @generated from field: google.protobuf.Timestamp mcp_token_expiry = 3;
   */
  mcpTokenExpiry?: Timestamp;

  /**
   * scm_tools_enabled indicates whether SCM tools should be available for this conversation
   *
   * @generated from field: optional bool scm_tools_enabled = 4;
   */
  scmToolsEnabled?: boolean;
};

/**
 * Describes the message agentops.v1.UpdateConversationRequest.
 * Use `create(UpdateConversationRequestSchema)` to create a new message.
 */
export const UpdateConversationRequestSchema: GenMessage<UpdateConversationRequest> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 3);

/**
 * @generated from message agentops.v1.UpdateConversationResponse
 */
export type UpdateConversationResponse = Message<"agentops.v1.UpdateConversationResponse"> & {
};

/**
 * Describes the message agentops.v1.UpdateConversationResponse.
 * Use `create(UpdateConversationResponseSchema)` to create a new message.
 */
export const UpdateConversationResponseSchema: GenMessage<UpdateConversationResponse> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 4);

/**
 * @generated from message agentops.v1.InterruptConversationRequest
 */
export type InterruptConversationRequest = Message<"agentops.v1.InterruptConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message agentops.v1.InterruptConversationRequest.
 * Use `create(InterruptConversationRequestSchema)` to create a new message.
 */
export const InterruptConversationRequestSchema: GenMessage<InterruptConversationRequest> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 5);

/**
 * @generated from message agentops.v1.InterruptConversationResponse
 */
export type InterruptConversationResponse = Message<"agentops.v1.InterruptConversationResponse"> & {
};

/**
 * Describes the message agentops.v1.InterruptConversationResponse.
 * Use `create(InterruptConversationResponseSchema)` to create a new message.
 */
export const InterruptConversationResponseSchema: GenMessage<InterruptConversationResponse> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 6);

/**
 * @generated from message agentops.v1.GetConversationRequest
 */
export type GetConversationRequest = Message<"agentops.v1.GetConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message agentops.v1.GetConversationRequest.
 * Use `create(GetConversationRequestSchema)` to create a new message.
 */
export const GetConversationRequestSchema: GenMessage<GetConversationRequest> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 7);

/**
 * @generated from message agentops.v1.GetConversationResponse
 */
export type GetConversationResponse = Message<"agentops.v1.GetConversationResponse"> & {
  /**
   * @generated from field: agentops.v1.Conversation conversation = 1;
   */
  conversation?: Conversation;
};

/**
 * Describes the message agentops.v1.GetConversationResponse.
 * Use `create(GetConversationResponseSchema)` to create a new message.
 */
export const GetConversationResponseSchema: GenMessage<GetConversationResponse> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 8);

/**
 * @generated from message agentops.v1.ListConversationsRequest
 */
export type ListConversationsRequest = Message<"agentops.v1.ListConversationsRequest"> & {
};

/**
 * Describes the message agentops.v1.ListConversationsRequest.
 * Use `create(ListConversationsRequestSchema)` to create a new message.
 */
export const ListConversationsRequestSchema: GenMessage<ListConversationsRequest> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 9);

/**
 * @generated from message agentops.v1.ListConversationsResponse
 */
export type ListConversationsResponse = Message<"agentops.v1.ListConversationsResponse"> & {
  /**
   * @generated from field: repeated agentops.v1.Conversation conversations = 1;
   */
  conversations: Conversation[];
};

/**
 * Describes the message agentops.v1.ListConversationsResponse.
 * Use `create(ListConversationsResponseSchema)` to create a new message.
 */
export const ListConversationsResponseSchema: GenMessage<ListConversationsResponse> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 10);

/**
 * @generated from message agentops.v1.SendMessageRequest
 */
export type SendMessageRequest = Message<"agentops.v1.SendMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: agentops.v1.UserInputMessage user_input = 2 [deprecated = true];
   * @deprecated
   */
  userInput?: UserInputMessage;

  /**
   * @generated from field: gitpod.v1.UserInputBlock input = 3;
   */
  input?: UserInputBlock;

  /**
   * @generated from field: string session = 4;
   */
  session: string;
};

/**
 * Describes the message agentops.v1.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 11);

/**
 * @generated from message agentops.v1.SendMessageResponse
 */
export type SendMessageResponse = Message<"agentops.v1.SendMessageResponse"> & {
};

/**
 * Describes the message agentops.v1.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 12);

/**
 * @generated from message agentops.v1.SubscribeToConversationRequest
 */
export type SubscribeToConversationRequest = Message<"agentops.v1.SubscribeToConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * after_iteration specifies the iteration to start streaming from.
   * 0 means stream from the beginning.
   *
   * @generated from field: int64 after_iteration = 2;
   */
  afterIteration: bigint;
};

/**
 * Describes the message agentops.v1.SubscribeToConversationRequest.
 * Use `create(SubscribeToConversationRequestSchema)` to create a new message.
 */
export const SubscribeToConversationRequestSchema: GenMessage<SubscribeToConversationRequest> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 13);

/**
 * @generated from message agentops.v1.SubscribeToConversationResponse
 */
export type SubscribeToConversationResponse = Message<"agentops.v1.SubscribeToConversationResponse"> & {
  /**
   * should be oneof, this needs to remain backwards compatible
   *
   * @generated from field: agentops.v1.AgentResponseBlock block = 1 [deprecated = true];
   * @deprecated
   */
  block?: AgentResponseBlock;

  /**
   * @generated from oneof agentops.v1.SubscribeToConversationResponse.update
   */
  update: {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock response = 10;
     */
    value: AgentResponseBlock$1;
    case: "response";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.Status status = 20;
     */
    value: AgentExecution_Status;
    case: "status";
  } | {
    /**
     * @generated from field: string name = 30;
     */
    value: string;
    case: "name";
  } | {
    /**
     * @generated from field: agentops.v1.SubscribeToConversationResponse.IterationComplete iteration_complete = 35;
     */
    value: SubscribeToConversationResponse_IterationComplete;
    case: "iterationComplete";
  } | { case: undefined; value?: undefined };

  /**
   * W3C trace context (traceparent/tracestate) for connecting the in-env
   * engine trace to the runner-side response processing.
   *
   * @generated from field: map<string, string> trace_context = 40;
   */
  traceContext: { [key: string]: string };
};

/**
 * Describes the message agentops.v1.SubscribeToConversationResponse.
 * Use `create(SubscribeToConversationResponseSchema)` to create a new message.
 */
export const SubscribeToConversationResponseSchema: GenMessage<SubscribeToConversationResponse> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 14);

/**
 * IterationComplete signals the end of an iteration in the conversation.
 *
 * @generated from message agentops.v1.SubscribeToConversationResponse.IterationComplete
 */
export type SubscribeToConversationResponse_IterationComplete = Message<"agentops.v1.SubscribeToConversationResponse.IterationComplete"> & {
  /**
   * @generated from field: int64 iteration = 1;
   */
  iteration: bigint;
};

/**
 * Describes the message agentops.v1.SubscribeToConversationResponse.IterationComplete.
 * Use `create(SubscribeToConversationResponse_IterationCompleteSchema)` to create a new message.
 */
export const SubscribeToConversationResponse_IterationCompleteSchema: GenMessage<SubscribeToConversationResponse_IterationComplete> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 14, 0);

/**
 * @generated from message agentops.v1.UserInputMessage
 */
export type UserInputMessage = Message<"agentops.v1.UserInputMessage"> & {
  /**
   * @generated from oneof agentops.v1.UserInputMessage.content
   */
  content: {
    /**
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message agentops.v1.UserInputMessage.
 * Use `create(UserInputMessageSchema)` to create a new message.
 */
export const UserInputMessageSchema: GenMessage<UserInputMessage> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 15);

/**
 * @generated from message agentops.v1.AgentResponseBlock
 */
export type AgentResponseBlock = Message<"agentops.v1.AgentResponseBlock"> & {
  /**
   * id is the unique identifier of the response block. A conversation can have multiple blocks with the same ID.
   * Clients are expected to use the ID to update or replace a block.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * parent_id is the ID of the parent block. A block can have at most one parent block.
   * If a block has no parent, the parent_id is the empty string.
   *
   * @generated from field: string parent_id = 2;
   */
  parentId: string;

  /**
   * @generated from oneof agentops.v1.AgentResponseBlock.output
   */
  output: {
    /**
     * @generated from field: agentops.v1.UserInputMessage user_input = 9;
     */
    value: UserInputMessage;
    case: "userInput";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.TextOutput text = 10;
     */
    value: AgentResponseBlock_TextOutput;
    case: "text";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.ActionStarted action_started = 20;
     */
    value: AgentResponseBlock_ActionStarted;
    case: "actionStarted";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.ActionCompleted action_completed = 21;
     */
    value: AgentResponseBlock_ActionCompleted;
    case: "actionCompleted";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.FileModification file_modification = 30;
     */
    value: AgentResponseBlock_FileModification;
    case: "fileModification";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.EnvironmentCreation environment_creation = 40;
     */
    value: AgentResponseBlock_EnvironmentCreation;
    case: "environmentCreation";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.CodeAnnotation code_annotation = 50;
     */
    value: AgentResponseBlock_CodeAnnotation;
    case: "codeAnnotation";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.HostAuthenticationRequired host_authentication_required = 60;
     */
    value: AgentResponseBlock_HostAuthenticationRequired;
    case: "hostAuthenticationRequired";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.TodoItem todo_item = 70;
     */
    value: AgentResponseBlock_TodoItem;
    case: "todoItem";
  } | {
    /**
     * @generated from field: agentops.v1.AgentResponseBlock.Thought thought = 80;
     */
    value: AgentResponseBlock_Thought;
    case: "thought";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.
 * Use `create(AgentResponseBlockSchema)` to create a new message.
 */
export const AgentResponseBlockSchema: GenMessage<AgentResponseBlock> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16);

/**
 * @generated from message agentops.v1.AgentResponseBlock.TextOutput
 */
export type AgentResponseBlock_TextOutput = Message<"agentops.v1.AgentResponseBlock.TextOutput"> & {
  /**
   * @generated from field: agentops.v1.AgentResponseBlock.TextOutput.Type type = 1;
   */
  type: AgentResponseBlock_TextOutput_Type;

  /**
   * @generated from field: string content = 2;
   */
  content: string;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.TextOutput.
 * Use `create(AgentResponseBlock_TextOutputSchema)` to create a new message.
 */
export const AgentResponseBlock_TextOutputSchema: GenMessage<AgentResponseBlock_TextOutput> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 0);

/**
 * @generated from enum agentops.v1.AgentResponseBlock.TextOutput.Type
 */
export enum AgentResponseBlock_TextOutput_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_USER_FACING_OUTPUT = 1;
   */
  USER_FACING_OUTPUT = 1,

  /**
   * @generated from enum value: TYPE_THOUGHTS = 2;
   */
  THOUGHTS = 2,
}

/**
 * Describes the enum agentops.v1.AgentResponseBlock.TextOutput.Type.
 */
export const AgentResponseBlock_TextOutput_TypeSchema: GenEnum<AgentResponseBlock_TextOutput_Type> = /*@__PURE__*/
  enumDesc(file_agentops_v1_agentops, 16, 0, 0);

/**
 * @generated from message agentops.v1.AgentResponseBlock.ActionStarted
 */
export type AgentResponseBlock_ActionStarted = Message<"agentops.v1.AgentResponseBlock.ActionStarted"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string intent_description = 2;
   */
  intentDescription: string;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.ActionStarted.
 * Use `create(AgentResponseBlock_ActionStartedSchema)` to create a new message.
 */
export const AgentResponseBlock_ActionStartedSchema: GenMessage<AgentResponseBlock_ActionStarted> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 1);

/**
 * @generated from message agentops.v1.AgentResponseBlock.ActionCompleted
 */
export type AgentResponseBlock_ActionCompleted = Message<"agentops.v1.AgentResponseBlock.ActionCompleted"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string result_description = 2;
   */
  resultDescription: string;

  /**
   * @generated from field: bool failed = 3;
   */
  failed: boolean;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.ActionCompleted.
 * Use `create(AgentResponseBlock_ActionCompletedSchema)` to create a new message.
 */
export const AgentResponseBlock_ActionCompletedSchema: GenMessage<AgentResponseBlock_ActionCompleted> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 2);

/**
 * @generated from message agentops.v1.AgentResponseBlock.FileModification
 */
export type AgentResponseBlock_FileModification = Message<"agentops.v1.AgentResponseBlock.FileModification"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string file_path = 2;
   */
  filePath: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.FileModification.
 * Use `create(AgentResponseBlock_FileModificationSchema)` to create a new message.
 */
export const AgentResponseBlock_FileModificationSchema: GenMessage<AgentResponseBlock_FileModification> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 3);

/**
 * @generated from message agentops.v1.AgentResponseBlock.EnvironmentCreation
 */
export type AgentResponseBlock_EnvironmentCreation = Message<"agentops.v1.AgentResponseBlock.EnvironmentCreation"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.EnvironmentCreation.
 * Use `create(AgentResponseBlock_EnvironmentCreationSchema)` to create a new message.
 */
export const AgentResponseBlock_EnvironmentCreationSchema: GenMessage<AgentResponseBlock_EnvironmentCreation> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 4);

/**
 * @generated from message agentops.v1.AgentResponseBlock.HostAuthenticationRequired
 */
export type AgentResponseBlock_HostAuthenticationRequired = Message<"agentops.v1.AgentResponseBlock.HostAuthenticationRequired"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string host = 2;
   */
  host: string;

  /**
   * @generated from field: string runner_id = 3;
   */
  runnerId: string;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.HostAuthenticationRequired.
 * Use `create(AgentResponseBlock_HostAuthenticationRequiredSchema)` to create a new message.
 */
export const AgentResponseBlock_HostAuthenticationRequiredSchema: GenMessage<AgentResponseBlock_HostAuthenticationRequired> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 5);

/**
 * @generated from message agentops.v1.AgentResponseBlock.CodeAnnotation
 */
export type AgentResponseBlock_CodeAnnotation = Message<"agentops.v1.AgentResponseBlock.CodeAnnotation"> & {
  /**
   * @generated from field: string file_path = 1;
   */
  filePath: string;

  /**
   * @generated from field: int32 start_line = 2;
   */
  startLine: number;

  /**
   * @generated from field: int32 end_line = 3;
   */
  endLine: number;

  /**
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.CodeAnnotation.
 * Use `create(AgentResponseBlock_CodeAnnotationSchema)` to create a new message.
 */
export const AgentResponseBlock_CodeAnnotationSchema: GenMessage<AgentResponseBlock_CodeAnnotation> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 6);

/**
 * @generated from message agentops.v1.AgentResponseBlock.TodoItem
 */
export type AgentResponseBlock_TodoItem = Message<"agentops.v1.AgentResponseBlock.TodoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: bool completed = 3;
   */
  completed: boolean;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.TodoItem.
 * Use `create(AgentResponseBlock_TodoItemSchema)` to create a new message.
 */
export const AgentResponseBlock_TodoItemSchema: GenMessage<AgentResponseBlock_TodoItem> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 7);

/**
 * @generated from message agentops.v1.AgentResponseBlock.Thought
 */
export type AgentResponseBlock_Thought = Message<"agentops.v1.AgentResponseBlock.Thought"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;
};

/**
 * Describes the message agentops.v1.AgentResponseBlock.Thought.
 * Use `create(AgentResponseBlock_ThoughtSchema)` to create a new message.
 */
export const AgentResponseBlock_ThoughtSchema: GenMessage<AgentResponseBlock_Thought> = /*@__PURE__*/
  messageDesc(file_agentops_v1_agentops, 16, 8);

/**
 * AgentOpsService is a service for managing agent conversations. This service is exposed by an agent iself.
 *
 * @generated from service agentops.v1.AgentOpsService
 */
export const AgentOpsService: GenService<{
  /**
   * CreateConversation creates a new conversation.
   *
   * @generated from rpc agentops.v1.AgentOpsService.CreateConversation
   */
  createConversation: {
    methodKind: "unary";
    input: typeof CreateConversationRequestSchema;
    output: typeof CreateConversationResponseSchema;
  },
  /**
   * UpdateConversation updates an existing conversation.
   *
   * @generated from rpc agentops.v1.AgentOpsService.UpdateConversation
   */
  updateConversation: {
    methodKind: "unary";
    input: typeof UpdateConversationRequestSchema;
    output: typeof UpdateConversationResponseSchema;
  },
  /**
   * InterruptConversation interrupts a conversation and stops the agent from executing the current task.
   * Use SendMessage to resume the conversation.
   *
   * @generated from rpc agentops.v1.AgentOpsService.InterruptConversation
   */
  interruptConversation: {
    methodKind: "unary";
    input: typeof InterruptConversationRequestSchema;
    output: typeof InterruptConversationResponseSchema;
  },
  /**
   * GetConversation gets a conversation by ID.
   *
   * @generated from rpc agentops.v1.AgentOpsService.GetConversation
   */
  getConversation: {
    methodKind: "unary";
    input: typeof GetConversationRequestSchema;
    output: typeof GetConversationResponseSchema;
  },
  /**
   * ListConversations lists all conversations for the agent.
   *
   * @generated from rpc agentops.v1.AgentOpsService.ListConversations
   */
  listConversations: {
    methodKind: "unary";
    input: typeof ListConversationsRequestSchema;
    output: typeof ListConversationsResponseSchema;
  },
  /**
   * SendMessage sends a message to the agent. Depending on your authentication, this might result in a permission denied error.
   *
   * @generated from rpc agentops.v1.AgentOpsService.SendMessage
   */
  sendMessage: {
    methodKind: "unary";
    input: typeof SendMessageRequestSchema;
    output: typeof SendMessageResponseSchema;
  },
  /**
   * SubscribeToConversation subscribes to a conversation. Doing so will stream the conversation to the client, starting from the first message.
   *
   * @generated from rpc agentops.v1.AgentOpsService.SubscribeToConversation
   */
  subscribeToConversation: {
    methodKind: "server_streaming";
    input: typeof SubscribeToConversationRequestSchema;
    output: typeof SubscribeToConversationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentops_v1_agentops, 0);

